import { Component, Input, OnInit } from '@angular/core';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { FormControlName, FormGroup, FormGroupDirective } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { CustomDateAdapter } from '@shared/adapters/custom-date.adapter';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { format, startOfDay } from 'date-fns';

const INPUT_DATE_FORMATS = {
  parse: {
    dateInput: 'dd/MM/yyyy',
  },
  display: {
    dateInput: 'dd/MM/yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'dd/MM/yyyy',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};

@Component({
  selector: 'app-input-date-picker',
  templateUrl: './input-date-picker.component.html',
  styleUrls: ['./input-date-picker.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: INPUT_DATE_FORMATS },
  ],
})
export class InputDatePickerComponent implements OnInit {
  @Input() placeholder = 'Silahkan input tanggal';
  @Input() isDisabled = false;
  @Input() minDate: Date | null;
  @Input() maxDate: Date | null;

  form: FormGroup;
  // value!: Date | null;
  constructor(
    private formGroupDirective: FormGroupDirective,
    private formControlNameDirective: FormControlName
  ) {}

  get ControlName() {
    return this.formControlNameDirective.name;
  }

  ngOnInit(): void {
    this.form = this.formGroupDirective.form;
  }

  onDateChange(e: MatDatepickerInputEvent<Date>) {
    const ctrl = this.formGroupDirective.getControl(this.formControlNameDirective);
    const date = e.value;

    if (ctrl && date) {
      const formattedDate = format(startOfDay(date), 'yyyy-MM-dd');
      ctrl.setValue(formattedDate, { emitEvent: true });
    }
  }

  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
}
